import { clsx } from "cn";

import { BwCloseLine, BwDownloadCloud2Line } from "@/components/ui/icons";

type LightBoxHeaderProps = {
  slideIndex: number;
  totalSlides: number;
  onZoomIn?: () => void;
  onZoomOut?: () => void;
  onClose?: () => void;
  urlDownload?: string;
  dataTest?: string;
};

const LightBoxHeader = (props: LightBoxHeaderProps) => {
  const { slideIndex, totalSlides, onZoomIn, onZoomOut, onClose, urlDownload } =
    props;

  return (
    <div
      className={clsx(
        "absolute left-0 top-0 w-full z-10 py-5 px-6",
        "flex items-center justify-start text-left sm:justify-center sm:text-center",
      )}
    >
      {totalSlides > 1 && (
        <p className="w-32 font-normal text-text-light/94">
          {slideIndex + 1}/{totalSlides}
        </p>
      )}
      <div
        className="absolute flex items-center gap-2 top-4 right-6"
        data-test={props["dataTest"]}
      >
        {/* {onZoomOut && (
          <Button onClick={onZoomOut}>
            <Icon name="icon-zoom-out" />
          </Button>
        )}
        {onZoomIn && (
          <Button onClick={onZoomIn}>
            <Icon name="icon-zoom-in" />
          </Button>
        )} */}
        {urlDownload && (
          <a
            href={urlDownload}
            download={true}
            target="_self"
            rel="noreferrer"
            data-test="light-box-download-button"
          >
            <div className="flex items-center justify-center w-8 h-8 rounded-lg cursor-pointer">
              <BwDownloadCloud2Line size={18} className="text-text-light" />
            </div>
          </a>
        )}
        {onClose && (
          <div
            data-test="light-box-close-button"
            className="flex items-center justify-center w-8 h-8 rounded-lg cursor-pointer"
            onClick={onClose}
          >
            <BwCloseLine size={18} className="text-text-light" />
          </div>
        )}
      </div>
    </div>
  );
};

export default LightBoxHeader;
